/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
import React, { memo, useCallback, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import withStyles from '@material-ui/core/styles/withStyles';
import Container from '@material-ui/core/Container';
import qs from 'query-string';
import isEmpty from 'lodash/isEmpty';
import { useDeepEffect } from 'aurora-hooks';
import { fetchContractsV2 } from 'aurora-composition/modules/contracts/actions';
import history from 'aurora-utils/history';
import { useLocation } from 'react-router-dom';
import { keyEmptyCheck } from 'aurora-utils/utils';
import allFilters from 'aurora-utils/filters.json';
import { ADGMFilters } from 'aurora-section-components';
import FILTERS_NAMES from 'aurora-utils/filtersNames';
import { isArray } from 'lodash';
import Contracts from './Contracts';
import { contractTypes as types } from './constants';

import styles from './styles';
import ADGMButton from '../ADGMButton';

const PAGE_SIZE = 10;

const switchOptions = [
  { label: keyEmptyCheck('Lease'), value: types.lease },
  { label: keyEmptyCheck('pma'), value: types.pma },
  { label: keyEmptyCheck('off_plan'), value: types.offPlan },
  // { label: keyEmptyCheck('musataha'), value: types.musataha },
  { label: keyEmptyCheck('mortgage'), value: types.mortgage },
  { label: keyEmptyCheck('POA'), value: types.poa },
];

function ADGMContracts(props) {
  const {
    classes,
    breadCrumbs,
    type: typeProp,
    defaultFilters,
    requiredFilters,
    selectable,
    showSwitch,
    onNext,
    hideContractDetailsBtn,
    footerBtnLabel,
    requiredFiltersDropDowns,
    hideLeaseTypeToggle,
    isSubLeaseService,
  } = props;
  const {
    location: { state: browserState },
  } = history;
  const [selected, setSelected] = useState(null);
  const [searchQuery, setSearchQuery] = useState(null);
  const { search } = useLocation();
  const query = qs.parse(search);

  const { page = 1, ...filters } = query;

  const isSublease = query?.isSublease || 'false';

  const type = typeProp || query.type || types.lease;

  const { contracts, loading, error, locale } = useSelector(
    createSelector(
      state => state.contractReducer,
      state => state.language,
      (contract, language) => ({
        loading: contract.loading,
        error: contract.error,
        contracts: contract.contracts,
        locale: language.locale,
      }),
    ),
  );
  const dispatch = useDispatch();
  useDeepEffect(() => {
    const payload = {
      page,
      pageSize: PAGE_SIZE,
      filters: {
        ...filters,
        contractSearchType: type || filters?.contractSearchType || types.lease,
        ...(isSubLeaseService && { isPropertyActive: true }),
      },
      defaultFilters,
    };

    dispatch(fetchContractsV2(payload));
  }, [filters, type, defaultFilters, page, isSubLeaseService]);

  const updatedBreadCrumbs = useMemo(() => {
    if (breadCrumbs?.length > 0) return breadCrumbs;
    if (!showSwitch) return [];
    const selectedTabSwitchOption = switchOptions.find(option => option?.value === type);
    return [
      { text: keyEmptyCheck('back_to_home'), to: '/app/home' },
      { text: keyEmptyCheck('My_contracts') },
      ...(selectedTabSwitchOption ? [{ text: selectedTabSwitchOption?.label }] : []),
    ];
  }, [breadCrumbs, type, showSwitch]);

  const requiredFiltersData = useMemo(() => {
    if (isArray(requiredFilters) && !isEmpty(requiredFilters)) return requiredFilters;
    switch (type) {
      case types.pma:
        return [
          FILTERS_NAMES.CONTRACT_ID,
          FILTERS_NAMES.BUILDING_REG_NUMBER,
          FILTERS_NAMES.UNIT_NUMBER_OR_NAME,
          FILTERS_NAMES.PLOT_NUMBER,
          // FILTERS_NAMES.PMA_CLASSIFICATION,
          FILTERS_NAMES.CONTRACT_CLASSIFICATION_ID,
          FILTERS_NAMES.CONTRACT_STATUS,
          FILTERS_NAMES.FROM_DATE,
          FILTERS_NAMES.TO_DATE,
          FILTERS_NAMES.UNIT_ID,
          FILTERS_NAMES.DISTRICT,
          FILTERS_NAMES.COMMUNITY,
        ];
      case types.lease:
        return [
          FILTERS_NAMES.CONTRACT_ID,
          FILTERS_NAMES.CONTRACT_CLASSIFICATION_TYPE,
          FILTERS_NAMES.TENANT_NAME,
          FILTERS_NAMES.CONTRACT_STATUS,
          FILTERS_NAMES.FROM_DATE,
          FILTERS_NAMES.TO_DATE,
          FILTERS_NAMES.UNIT_NUMBER_OR_NAME,
          FILTERS_NAMES.BUILDING_REG_NUMBER,
          FILTERS_NAMES.TENANT_UNIFIED_EID_OR_TL_NUM,
          FILTERS_NAMES.TENANT_PHONE_NUMBER,
          FILTERS_NAMES.DISTRICT,
          FILTERS_NAMES.COMMUNITY,
        ];
      case types.offPlan:
        return [
          FILTERS_NAMES.CONTRACT_ID,
          FILTERS_NAMES.CONTRACT_STATUS,
          FILTERS_NAMES.FROM_DATE,
          FILTERS_NAMES.TO_DATE,
          FILTERS_NAMES.UNIT_NUMBER,
          FILTERS_NAMES.PLOT_NUMBER,
          FILTERS_NAMES.DISTRICT,
          FILTERS_NAMES.COMMUNITY,
          FILTERS_NAMES.PROJECT_NAME,
          FILTERS_NAMES.BUILDING_NUMBER,
          FILTERS_NAMES.FLOOR_NUMBER,
        ];
      case types.musataha:
        return [
          FILTERS_NAMES.CONTRACT_ID,
          FILTERS_NAMES.CONTRACT_STATUS,
          FILTERS_NAMES.FROM_DATE,
          FILTERS_NAMES.TO_DATE,

          FILTERS_NAMES.DISTRICT,
          FILTERS_NAMES.COMMUNITY,
          FILTERS_NAMES.PLOT_NUMBER,
          FILTERS_NAMES.ALLOCATION_TYPE,
          FILTERS_NAMES.PAYMENT_STATUS,
        ];
      case types.mortgage:
        return [
          FILTERS_NAMES.CONTRACT_ID,
          FILTERS_NAMES.PLOT_NUMBER,
          FILTERS_NAMES.UNIT_NUMBER,
          FILTERS_NAMES.PROJECT_NAME_MORTGAGE,
          FILTERS_NAMES.BUILDING_NAME,
          FILTERS_NAMES.DISTRICT,
          FILTERS_NAMES.COMMUNITY,
          FILTERS_NAMES.FROM_DATE,
          FILTERS_NAMES.TO_DATE,
        ];
      case types.poa:
        return [
          FILTERS_NAMES.CONTRACT_ID,
          FILTERS_NAMES.PLOT_NUMBER,
          FILTERS_NAMES.UNIT_NUMBER,
          FILTERS_NAMES.DISTRICT,
          FILTERS_NAMES.COMMUNITY,
          FILTERS_NAMES.FROM_DATE,
          FILTERS_NAMES.TO_DATE,
        ];
      default:
        return [];
    }
  }, [type]);

  const handleQueryChange = useCallback(newQuery => {
    history.replace({ search: qs.stringify(newQuery) }, { ...browserState });
    setSearchQuery(newQuery);
  }, []);

  const handleSwitchChange = useCallback(
    newType => {
      const newQuery = { type: newType, page: 1 };
      handleQueryChange(newQuery);
    },
    [query, searchQuery],
  );

  const handleSearch = useCallback(
    appliedFilters => {
      const newQuery = { type, page: 1, ...appliedFilters, isSublease };
      handleQueryChange(newQuery);
    },
    [query, searchQuery],
  );

  const handleResetFilters = useCallback(() => {
    const newQuery = { type, page: 1 };
    handleQueryChange(newQuery);
  }, [type]);

  const handleNext = useCallback(() => {
    onNext && onNext(selected);
  }, [selected]);

  const onNextDisabled = useMemo(() => {
    if (loading || isEmpty(selected)) return true;
    return false;
  }, [selected, loading]);

  const { location: { pathname = '' } = {} } = history;

  const getDropdownData = requiredOptionValues => {
    const lang = localStorage.getItem('lang');
    return allFilters.contractStatus
      ?.filter(option => requiredOptionValues.includes(option?.value))
      ?.map(item => ({
        value: item.value,
        label: lang === 'ar' ? item.labelAr : item.labelEn,
      }));
  };

  const PMAContractStatus = useMemo(() => {
    const dropDownOptions = [];
    if (pathname === '/app/contracts' && type === 'Pma') {
      return {
        contractStatus: getDropdownData(['Active', 'Expired', 'Cancelled']),
      };
    }
    null;
  }, [pathname, type]);

  const handleLeaseType = useCallback(
    value => {
      const newQuery = { ...query, page: 1, isSublease: value };
      handleQueryChange(newQuery);
    },
    [query],
  );

  const leaseTypeFilterOptions = useMemo(() => {
    if (type !== 'Lease' || hideLeaseTypeToggle) return [];
    const options = [
      {
        label: keyEmptyCheck('master_lease'),
        value: 'false',
      },
      { label: keyEmptyCheck('sub_lease'), value: 'true' },
    ];

    return options;
  }, []);

  return (
    <div className={classes.container}>
      <ADGMFilters
        filtersApiParams={{
          ...([types.offPlan].includes(type) && {
            [FILTERS_NAMES.PROJECT_NAME]: {
              isElmsProjectId: true,
            },
          }),
        }}
        loading={loading}
        breadCrumbs={updatedBreadCrumbs}
        title={keyEmptyCheck('My_contracts')}
        totalResults={contracts?.recordsTotal || contracts?.totalCount}
        {...(showSwitch === true && {
          selectedSwitch: type,
          switchOptions,
          onSwitchChange: handleSwitchChange,
        })}
        {...(type === 'Lease' &&
          !hideLeaseTypeToggle && {
            leaseTypeFilterOptions,
            selectedLeaseTypeFilter: isSublease,
            onLeaseTypeFilterChange: handleLeaseType,
          })}
        query={query}
        requiredFilters={requiredFiltersData}
        REQUIRED_SIDEBAR_FILTERS_LENGTH={type === types.poa && 5}
        onSearch={handleSearch}
        onFiltersReset={handleResetFilters}
        error={error}
        customClasses={{
          ...(selectable && { root: classes.paddingBottom }),
        }}
        requiredFiltersDropDowns={PMAContractStatus || requiredFiltersDropDowns}
      >
        <Contracts
          locale={locale}
          loading={loading}
          query={query}
          type={type}
          selectable={selectable}
          data={contracts}
          page={page}
          selected={selected}
          setSelected={setSelected}
          handleQueryChange={handleQueryChange}
          defaultFilters={defaultFilters}
          hideContractDetailsBtn={hideContractDetailsBtn}
        />
        {/* Next button footer */}
        {selectable && (
          <div className={classes.footer}>
            <Container className={classes.footerContainer}>
              <ADGMButton variant='secondary' onClick={() => history.push('/app/services')}>
                {keyEmptyCheck('cancel')}
              </ADGMButton>
              <ADGMButton
                className={classes.footerBtn}
                variant='primary'
                onClick={handleNext}
                disabled={onNextDisabled}
              >
                {footerBtnLabel ?? keyEmptyCheck('proceed')}
              </ADGMButton>
            </Container>
          </div>
        )}
      </ADGMFilters>
    </div>
  );
}

ADGMContracts.propTypes = {
  classes: PropTypes.object.isRequired,
  breadCrumbs: PropTypes.array,
  type: PropTypes.string,
  defaultFilters: PropTypes.object,
  requiredFilters: PropTypes.array,
  selectable: PropTypes.bool,
  showSwitch: PropTypes.bool,
  onNext: PropTypes.func,
  hideContractDetailsBtn: PropTypes.bool,
  footerBtnLabel: PropTypes.string,
  requiredFiltersDropDowns: PropTypes.object,
  hideLeaseTypeToggle: PropTypes.bool,
  isSubLeaseService: PropTypes.bool,
};

ADGMContracts.defaultProps = {
  breadCrumbs: [],
  type: null,
  defaultFilters: {},
  requiredFilters: [],
  selectable: false,
  showSwitch: false,
  onNext: null,
  hideContractDetailsBtn: false,
  footerBtnLabel: null,
  requiredFiltersDropDowns: {},
  hideLeaseTypeToggle: true,
  isSubLeaseService: false,
};

export default withStyles(styles)(memo(ADGMContracts));
